import { render, staticRenderFns } from "./createPredictionModal.vue?vue&type=template&id=eb8be6d2&scoped=true&"
import script from "./createPredictionModal.vue?vue&type=script&lang=js&"
export * from "./createPredictionModal.vue?vue&type=script&lang=js&"
import style0 from "./createPredictionModal.vue?vue&type=style&index=0&id=eb8be6d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8be6d2",
  null
  
)

export default component.exports